module.exports = __webpack_public_path__ + "static/img/jnv.075cb432.svg";